import Meanings from "./Meanings";
import "./Results.css";
import Audio from "./Audio";
import Images from "./Images";

export default function Results(props) {
  const word = props.word;

  if (!word) {
    return null;
  }

  if (!word.meanings || word.meanings.length === 0) {
    return <p>No definition found. Try another word!</p>;
  }

  return (
    <div className="results">
      <h2 className="glow-text ">
        <span>{word.word}</span>
        <span className="ps-5"> [{word.phonetic}]</span>
        <span>
          {" "}
          <Audio word={props.word.word} />{" "}
        </span>
      </h2>

      <Meanings word={word} />
      <div className="images">
        <Images keyword={props.word.word} />
      </div>
    </div>
  );
}
